export const AuthErrorMessages: { [key: string]: string } = {
  UserNotFoundException: 'User does not exist.',
  NotAuthorizedException: 'Incorrect username or password.',
  CodeMismatchException: 'Invalid verification code provided, please try again.',
  LimitExceededException: 'Attempt limit exceeded, please try after some time.',
};

export enum AwsAttributeName {
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
}
